import React from "react";
var __jsx = React.createElement;
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { timeFormat } from "./index";
import Tooltip from "../../../Tooltip";
import { BestBuyTradeStatus } from "../../../../hooks/useUserBestBuyList";
import { StyledItemContainer, StyledItemRow, StyledDateLabel, StyledStatusText } from "./styled";
import IconExclamationMark from "../../../../assets/images/exclamation-mark-grey-outlined.svg";

var NoTradingOccurredItem = _ref => {
  var trade = _ref.trade;
  var createdAt = trade.createdAt,
      status = trade.status;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isNotReached = status === BestBuyTradeStatus.NotReached;
  var isFailedBySlippage = status === BestBuyTradeStatus.TradeRateInvalid;
  var tip = isNotReached ? t('best_buy_trade_status_tip_not_reached') : isFailedBySlippage ? t('best_buy_trade_status_tip_failed_by_slippage') : t('best_buy_trade_status_tip_failed');
  return __jsx(StyledItemContainer, null, __jsx(StyledItemRow, null, __jsx(StyledDateLabel, null, dayjs(createdAt).format(timeFormat)), __jsx(StyledStatusText, null, t('best_buy_trade_status_no_trading_occurred'), __jsx(Tooltip, {
    overlayClassName: "limit-order-tooltip",
    placement: "topRight",
    title: tip,
    trigger: "hover",
    img: IconExclamationMark
  }))));
};

export default NoTradingOccurredItem;